import React from 'react';

const StarSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M6.00721 3.38587C6.89385 1.79529 7.33716 1 7.99999 1C8.66282 1 9.10613 1.79529 9.99275 3.38586L10.2221 3.79737C10.4741 4.24936 10.6001 4.47536 10.7966 4.62447C10.993 4.77359 11.2376 4.82894 11.7269 4.93964L12.1723 5.04043C13.8941 5.43 14.755 5.62478 14.9598 6.28342C15.1646 6.94203 14.5777 7.62838 13.4039 9.00094L13.1003 9.35605C12.7667 9.74609 12.5999 9.94111 12.5249 10.1824C12.4499 10.4237 12.4751 10.6839 12.5255 11.2043L12.5714 11.6781C12.7489 13.5094 12.8376 14.4251 12.3014 14.8322C11.7651 15.2392 10.9591 14.8681 9.347 14.1259L8.92994 13.9338C8.47186 13.7229 8.24282 13.6174 7.99999 13.6174C7.75716 13.6174 7.52812 13.7229 7.07004 13.9338L6.65298 14.1259C5.04087 14.8681 4.23482 15.2392 3.6986 14.8322C3.16238 14.4251 3.25111 13.5094 3.42858 11.6781L3.47448 11.2043C3.52492 10.6839 3.55013 10.4237 3.4751 10.1824C3.40007 9.94111 3.2333 9.74609 2.89974 9.35605L2.59607 9.00094C1.42228 7.62838 0.835376 6.94203 1.0402 6.28342C1.24502 5.62478 2.1059 5.43 3.82768 5.04043L4.27312 4.93964C4.76239 4.82894 5.00703 4.77359 5.20345 4.62447C5.39988 4.47536 5.52587 4.24936 5.77782 3.79737L6.00721 3.38587Z"
        stroke={color}
        strokeWidth="1.3"
      />
    </svg>
  );
};

export default StarSVG;
